import { useCallback, useEffect } from 'react';
import { rage } from '~/rage';
import { isRgbPaintType, rgbToHex, VehiclePaintType } from '~/shared';
import {
	CategoryTypes,
	colorSelectItems,
} from '../components/ColorSelect/ColorSelect.model';
import { useLayoutSelector } from '../redux';
export const usePaintPreview = () => {
	const activeIndex = useLayoutSelector(
		(state) => state.tuningStudio.activeIndex,
	);
	const activePaintGroup = useLayoutSelector(
		(state) => state.colorPicker.paintGroup,
	);
	const pearlColor = useLayoutSelector((state) => state.colorPicker.pearlColor);
	const indexedColor = useLayoutSelector(
		(state) => state.colorPicker.indexedColor,
	);
	const colorPickerSelectedColor = useLayoutSelector(
		(state) => state.colorPicker.selectedColor,
	);
	const rimsColor = useLayoutSelector((state) => state.colorPicker.rimsColor);
	const brakesColor = useLayoutSelector(
		(state) => state.colorPicker.brakesColor,
	);

	const currentItem = colorSelectItems[activeIndex];
	const isPaintingWorks = currentItem?.type === CategoryTypes.PaintingWorks;
	const isPaintingInterior =
		currentItem?.type === CategoryTypes.PaintingInterior;
	const isPaintingWheels = currentItem?.type === CategoryTypes.PaintingWheels;
	const isBrakes = currentItem?.type === CategoryTypes.Brakes;

	const previewBodyColor = useCallback(() => {
		if (!isPaintingWorks) return;

		const currentPaintType = activePaintGroup?.type || VehiclePaintType.Classic;
		const hasPearlColor =
			currentPaintType === VehiclePaintType.Pearl &&
			typeof pearlColor === 'number';

		const colorValue = !isRgbPaintType(currentPaintType)
			? indexedColor
			: rgbToHex(colorPickerSelectedColor || { r: 255, g: 255, b: 255 });

		rage.vehiclePaintShop.previewBodyColor(
			colorValue,
			currentPaintType,
			hasPearlColor ? pearlColor : null,
		);
	}, [
		isPaintingWorks,
		colorPickerSelectedColor,
		activePaintGroup,
		indexedColor,
		pearlColor,
	]);

	const previewInteriorColor = useCallback(() => {
		if (!isPaintingInterior) return;

		rage.vehiclePaintShop.previewInteriorColor(
			rgbToHex(colorPickerSelectedColor || { r: 255, g: 255, b: 255 }),
		);
	}, [isPaintingInterior, colorPickerSelectedColor]);

	const previewBrakesColor = useCallback(() => {
		if (!isBrakes || brakesColor == null) return;

		rage.vehiclePaintShop.previewBrakesColor(brakesColor);
	}, [isBrakes, brakesColor]);

	const previewRimsColor = useCallback(() => {
		if (!isPaintingWheels || !rimsColor) return;

		rage.vehiclePaintShop.previewRimsColor(rimsColor);
	}, [isPaintingWheels, rimsColor]);

	useEffect(() => {
		if (isPaintingWorks) {
			previewBodyColor();
		}

		if (isPaintingInterior) {
			previewInteriorColor();
		}

		if (isBrakes) {
			previewBrakesColor();
		}

		if (isPaintingWheels) {
			previewRimsColor();
		}
	}, [
		isPaintingWorks,
		isPaintingInterior,
		isPaintingWheels,
		isBrakes,
		previewBodyColor,
		previewInteriorColor,
		previewBrakesColor,
		previewRimsColor,
	]);
};
